export default "__VITE_ASSET__7936cdf9__"